import types from './mutation-types.js'

export default {
  [types.zbid](state, data) {
    state.zbid = data
  },
  // 微赞提供技术支持
  [types.vzandesc](state, data) {
    state.vzandesc = data
  },
  // 微信权限
  [types.setWxCofig](state, data) {
    state.wxconfig = data
  },
  [types.zbvd](state, data) {
    const liveStudioKey = `zbvd_${data.zbid}`
    let zbvd = Object.assign(state.zbvd, data)
    localStorage.setItem(liveStudioKey, JSON.stringify(zbvd))
    state.zbvd = zbvd
    window.zbvd = zbvd
  },
  [types.userInfo](state, data) {
    state.userInfo = data
    window.userInfo = data
  },
  // 峰会/展会
  [types.isSignIn](state, data) {
    state.isSignIn = data
  },
  [types.isSignUp](state, data) {
    state.isSignUp = data
  },
  [types.isUserNoPayment](state, data) {
    state.isUserNoPayment = data
  },
  [types.isTicket](state, data) {
    state.isTicket = data
  },
  [types.playbackType](state, data) {
    state.playbackType = data
  },
  [types.expoActivity](state, data) {
    state.expoActivity = data
  },
  [types.expoHasLive](state, data) {
    state.expoHasLive = data
  },
  [types.audioPlaying](state, data) {
    state.audioPlaying = data
  },
  [types.setStoreStyleInfo](state, data) {
    state.storeStyleInfo = data
  },
  [types.setMerchantMiniConfig](state, data) {
    state.merchantMiniConfig = data
  },
  [types.setCustomConfig](state, data) {
    state.customConfig = data
  },
  // 更新订单筛选
  [types.updateOrderFilterParams](state, data) {
    state.orderFilterParams = data
  },
  // 更新订单筛选-商品名称
  [types.updateOrderFilterParamsGoodsName](state, data) {
    state.orderFilterParamsNew.goodsName = data
  },
  // 更新订单筛选(new)
  [types.updateOrderFilterParamsNew](state, data) {
    state.orderFilterParamsNew = data
  },
  // 更新优惠券筛选
  [types.updateCouponFilterParams](state, data) {
    state.couponFilterParams = data
  },
  // 更新优惠券筛选(new)
  [types.updateCouponFilterParamsNew](state, data) {
    state.couponFilterParamsNew = data
  },
  // 更新商品统计筛选
  [types.updateGoodsFilterParams](state, data) {
    state.goodsFilterParams = data
  },
  // 更新商品统计筛选
  [types.updateGoodsFilterParamsNew](state, data) {
    state.goodsFilterParamsNew = data
  },
  [types.setAuthDataAndAgentSetting](state, data) {
    state.authDataAndAgentSetting = data
  },
  [types.setPersonalBalance](state, data) {
    state.personalBalance = data
  },
  [types.setShowedBindStorePopup](state, data) {
    state.showedBindStorePopup = data
  },
  [types.setAgentAuthList](state, data) {
    state.agentAuthList = data
    state.isFetchAgentAuthList = true
  },
  [types.isForBiddenLive](state, data) {
    state.isForBiddenLive = data
  },
  [types.setAgentGray](state, data) {
    state.isAgentGray = data
  },
  [types.setGuokeCustomization](state, data) {
    state.guokeCustomization = data
  },
  [types.setAgentTeamConfig](state, data) {
    state.agentTeamConfig = Object.assign({}, state.agentTeamConfig, data)
  },
  // 添加缓存的组件
  [types.addCachedComponent](state, componentName) {
    if (!state.cachedComponents.includes(componentName)) {
      state.cachedComponents.push(componentName)
    }
  },
  // 移除缓存的组件
  [types.removeCachedComponent](state, componentName) {
    const index = state.cachedComponents.indexOf(componentName)
    if (index !== -1) {
      state.cachedComponents.splice(index, 1)
    }
  },
  [types.setIntegral](state, integralInfo) {
    state.integral = {
      isRequest: true,
      integralInfo,
    }
  },
  // H5端获取用户自主核销配置
  [types.setSelfVerifyConfig](state, data) {
    state.selfVerifyConfig = data
  },
  [types.updateTime](state, time) {
    clearTimeout(state.system.clock)
    state.system.clock = null
    const localTime = Date.now()
    state.system.now = time
    state.system.offsetTime = time - localTime
    state.system.serverNow = time
    this.commit('START_CLOCK')
  },
  [types.startClock](state) {
    clearTimeout(state.clock)
    state.system.clock = setTimeout(() => {
      state.system.now += 1000
      state.system.serverNow = Date.now() + state.system.offsetTime
      this.commit('START_CLOCK')
    }, 1000)
  },
  [types.endClock](state) {
    clearTimeout(state.system.clock)
    state.clock = null
  },
  [types.setSupportFreightInsurance](state, info) {
    state.isSupportFreightInsurance = info
  },
  [types.setIsAgent](state, data) {
    state.isAgent = data
  },
  [types.update_fontsize](state, data) {
    state.fontSizeScale = data
  },
  [types.setBusinessModel](state, data) {
    state.businessModel = data
  },
  [types.setPayThirdType](state, type) {
    state.payThirdType = type
  },
  [types.setIsBanShareInline](state, bool) {
    state.iBanShareInline = bool
  }
}
